import "../../stylesheets/PopupRegister.css";
import React from "react";
import { useNavigate } from "react-router-dom";

function PopupMailEnviado({
  title = "",
  description = "",
  setOpenPopup,
  redirectTo = "/login",
}) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (typeof setOpenPopup === "function") setOpenPopup(false);
    navigate(redirectTo);
  };

  return (
    <>
      <div className="popup-register-container">
        <div className="popup">
          <div className="lightgreen">
            <img
              src={process.env.PUBLIC_URL + "/images/stage_characters/Popup_Imagen.png"}
              alt=""
            />
          </div>
          <h1>{title}</h1>
          <h2>{description}</h2>
          <button className="btn lightgreen-btn" onClick={handleClose}>
            Aceptar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupMailEnviado;
